import React from 'react';
import './DropDown.css';
import { DownArrowIcon } from 'src/SharedComponents/Icons/Icons';
import { memo } from "react";

interface IChildren {
    children: React.ReactNode;
    selectedItem: string;
    selectedElement?: React.ReactNode;
}
const DropDown: React.FC<IChildren> = ({children, selectedItem, selectedElement}) => {

    return (
        <div  >
            <div className="row menu-icons" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"  style={{ display: 'flex', alignItems: 'center' }}>
                <div className="col-md-6 channel-icon">
                    {selectedElement ?? <img src={selectedItem} alt='channel' className='icons-size'/>}
                </div>
                <div className="col-md-6 channel-options">
                    <DownArrowIcon />
                </div>
            </div>
            <ul className={`dropdown-menu`} aria-labelledby="dropdownMenuButton1">
               {children} 
            </ul>
            
        </div>
    );
};

export default memo(DropDown);
